module.exports = __webpack_public_path__ + "img/hypertension.41afee28.jpg";